// @flow
import React, { Component } from "react";
import Highlighter from "react-highlight-words";
import _ from "lodash";
import Waypoint from "react-waypoint";
import I18n from "../../../../i18n/I18n";
import {
  Button,
  ProductNameBox,
  Icon,
  LocaleLink,
  Status
} from "../../../common/";
import ItemNumber from "../../../orders/itemNumber/ItemNumber";
import Helper from "../../../../helper/Helper";
import styles from "../../../orders/orderTable/OrderTable.scss";

class AsnRow extends Component {
  state = {
    dialogOpen: false
  };
  openDialog = () => {
    this.setState({
      dialogOpen: true
    });
  };

  closeDialog = () => {
    this.setState({
      dialogOpen: false
    });
  };
  render() {
    const {
      lang,
      data,
      acceptedShow,
      asnType,
      seller,
      transfersType,
      history,
      searchString,
      property,
      scroll,
      imports,
      businessType,
      eligbleEnabled,
      barcodeRecvMethod
    } = this.props;

    const divStyle = {
      fontWeight: "600"
    };

    const splitBarcode =
      data && data.partner_barcode && data.partner_barcode.split(",");

    const barCodes = (
      <div>
        {splitBarcode
          ? splitBarcode.map(item => {
              return <div style={divStyle}>{item ? item : ""}</div>;
            })
          : ""}
      </div>
    );

    let itemNrs = [];

    if (data.item_nr) {
      itemNrs = data.item_nr.split(",");
    }

    const reasonStyle = {
      color: `#ce0f0f`,
      fontWeight: "bold"
    };

    const itemNrList =
      itemNrs && !_.isEmpty(itemNrs)
        ? itemNrs.map((singleItemNr, index) => (
            <div style={{ margin: "5px 0" }}>
              <ItemNumber
                itemNr={singleItemNr}
                seller={seller}
                history={history}
                searchString={searchString}
              />
            </div>
          ))
        : "";

    return (
      <tr className={`${styles.row}`}>
        {property.haveVal("title") ? (
          <td>
            <a
              // target="_blank"
              href={`${Helper.getAppDomain(
                "catalog"
              )}/${Helper.getLocale()}/catalog/${data.psku_canonical}`}
            >
              <ProductNameBox
                hideBadge
                data={data}
                searchString={searchString}
              />
            </a>
            {data.reject_reason ? (
              <div className={styles.rejectedReason}>
                {I18n.getText("transfers.rejected-reason")}:
                <span style={{ fontWeight: "400" }}>
                  &nbsp;{data.reject_reason}
                </span>
              </div>
            ) : (
              ""
            )}
          </td>
        ) : (
          ""
        )}
        {property.haveVal("partner_sku") ? (
          <td>
            {data.partner_sku ? (
              <Highlighter
                highlightClassName={styles.highlight}
                searchWords={[searchString]}
                autoEscape={true}
                textToHighlight={data.partner_sku}
              />
            ) : (
              "-"
            )}
          </td>
        ) : (
          ""
        )}
        {property.haveVal("partner_sku_unique") ? (
          <td>
            {data.partner_sku_unique ? (
              <Highlighter
                highlightClassName={styles.highlight}
                searchWords={[searchString]}
                autoEscape={true}
                textToHighlight={data.partner_sku_unique}
              />
            ) : (
              "-"
            )}
          </td>
        ) : (
          ""
        )}
        {property.haveVal("partner_barcode") && barcodeRecvMethod ? (
          <td>{data.partner_barcode ? barCodes : <td>--</td>}</td>
        ) : (
          ""
        )}
        {property.haveVal("sku") && !barcodeRecvMethod ? (
          <td>
            {data.sku ? (
              <Highlighter
                highlightClassName={styles.highlight}
                searchWords={[searchString]}
                autoEscape={true}
                textToHighlight={data.sku}
              />
            ) : (
              "-"
            )}
          </td>
        ) : (
          ""
        )}
        {property.haveVal("incoming_skunique") && imports ? (
          <td>
            {data.incoming_skunique ? (
              <Highlighter
                highlightClassName={styles.highlight}
                searchWords={[searchString]}
                autoEscape={true}
                textToHighlight={data.incoming_skunique}
              />
            ) : (
              "-"
            )}
          </td>
        ) : (
          ""
        )}
        {property.haveVal("item_nr") ? <td>{itemNrList}</td> : ""}
        {property.haveVal("reason_code") ? <td>{data.reason_code}</td> : ""}
        {property.haveVal("barcode_box") ? <td>{data.barcode_box}</td> : ""}
        {property.haveVal("wms_barcode_inner") ? (
          <td>{data.wms_barcode_inner}</td>
        ) : (
          ""
        )}
        {property.haveVal("ref_nr") ? (
          <td>
            {data.ref_nr ? (
              <Highlighter
                highlightClassName={styles.highlight}
                searchWords={[searchString]}
                autoEscape={true}
                textToHighlight={data.ref_nr}
              />
            ) : (
              "-"
            )}
          </td>
        ) : (
          ""
        )}
        {property.haveQtyVal("qty") ? <td>{data.qty}</td> : ""}
        {property.haveQtyVal("qty_expected") ? (
          <td>
            <div className={styles.qtyDefault}>{data.qty_expected}</div>
          </td>
        ) : (
          ""
        )}
        {property.haveQtyVal("qty_recv") ||
        property.haveQtyVal("qty_received") ? (
          <td>
            <div className={styles.qtyDefault}>
              {data.qty_recv || data.qty_received}
            </div>
          </td>
        ) : (
          ""
        )}
        {property.haveQtyVal("qty_rejected") ? (
          <td>
            <div
              className={`${styles.qtyDefault} ${
                data.qty_rejected > 0 ? styles.diff : ""
              }`}
            >
              {data.qty_rejected}
            </div>
          </td>
        ) : (
          ""
        )}
        {property.haveVal("slot") ? <td>{data.slot}</td> : ""}
        {eligbleEnabled ? (
          <td>
            <div
              className={`${styles.iconStatus} ${
                data.is_eligible ? "" : styles.warn
              }`}
            >
              <Icon name={data.is_eligible ? "tick" : "close"} />
            </div>
          </td>
        ) : (
          ""
        )}
        {property.haveVal("return_asn") ? (
          <td>
            {data.return_asn ? (
              <LocaleLink to={`/transfers/rtv/${data.return_asn}`}>
                <Button variant="dashed" className={styles.button}>
                  {data.return_asn}
                </Button>
              </LocaleLink>
            ) : (
              ""
            )}
          </td>
        ) : (
          ""
        )}
        {property.haveVal("parent_asn") ? (
          <td>
            {data.parent_asn ? (
              <LocaleLink to={`/transfers/asn/${data.parent_asn}`}>
                <Button variant="dashed" className={styles.button}>
                  {data.parent_asn}
                </Button>
              </LocaleLink>
            ) : (
              "-"
            )}
          </td>
        ) : (
          ""
        )}
        {property.haveVal("warehouse_code") ? (
          <td>{data.warehouse_code}</td>
        ) : scroll ? (
          ""
        ) : (
          <td />
        )}
        {property.haveQtyVal("incoming_stock") ? (
          <td>{data.incoming_stock}</td>
        ) : scroll ? (
          ""
        ) : (
          <td />
        )}
        {property.haveVal("incoming_processing_time") ? (
          <td>{data.incoming_processing_time}</td>
        ) : scroll ? (
          ""
        ) : (
          <td />
        )}
        {property.haveVal("status") ? (
          <td>
            <Status status={data.status} reason={data.error_reason} />
            <div style={reasonStyle}>{data && data.error_reason}</div>
          </td>
        ) : scroll ? (
          ""
        ) : (
          <td />
        )}
        {!scroll ? <td /> : ""}
      </tr>
    );
  }
}
export default AsnRow;



// WEBPACK FOOTER //
// ./src/components/transfers/asnTable/asnRow/AsnRow.js